import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface BasketItem {
  product_id: number;
  quantity: number;
  product: {
    id: number;
    name: string;
    price: number;
    formatted_price: string;
  };
}

interface BasketState {
  items: BasketItem[];
  isOpen: boolean;
  // Оплата начата: доступы перепроверяются при возврате на вкладку (usePostPaymentRefresh)
  paymentStartedAt: number | null;
  // Растёт после каждой покупки — по нему списки сбрасываются на первую страницу
  purchaseToken: number;
  // Задание, доступ к которому ждём после оплаты: по нему опрашивается бэкенд
  pendingAssignmentId: number | null;
  total: {
    raw: number | null;
    templated: string | null;
  };
  savings: {
    raw: number | null;
    templated: string | null;
  };
}

const initialState: BasketState = {
  items: [],
  isOpen: false,
  paymentStartedAt: null,
  purchaseToken: 0,
  pendingAssignmentId: null,
  total: { raw: null, templated: null },
  savings: { raw: null, templated: null },
};

export const basketSlice = createSlice({
  name: "basket",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    
    setItems: (state, action: PayloadAction<BasketItem[]>) => {
      state.items = action.payload;
    },
    
    setTotal: (state, action: PayloadAction<{ raw: number; templated: string }>) => {
      state.total = action.payload;
    },
    
    setSavings: (state, action: PayloadAction<{ raw: number; templated: string }>) => {
      state.savings = action.payload;
    },
    
    clearBasket: (state) => {
      state.items = [];
    },

    paymentStarted: (state) => {
      state.paymentStartedAt = Date.now();
    },

    paymentSettled: (state) => {
      state.paymentStartedAt = null;
      state.pendingAssignmentId = null;
    },

    /* Ставится, когда задание положили в корзину и повели к оплате: с этого момента
       usePostPaymentRefresh знает, у какого задания перепроверять доступ. */
    purchaseIntent: (state, action: PayloadAction<number>) => {
      state.pendingAssignmentId = action.payload;
    },

    purchaseCompleted: (state) => {
      state.paymentStartedAt = null;
      state.pendingAssignmentId = null;
      state.purchaseToken += 1;
    },
  },
});

export const {
  setOpen,
  setItems,
  setTotal,
  setSavings,
  clearBasket,
  paymentStarted,
  paymentSettled,
  purchaseIntent,
  purchaseCompleted,
} = basketSlice.actions;

export default basketSlice.reducer;
